
import fiMessages from '../locales/fi_FI';

const FiLang = {
    messages: {
        ...fiMessages
    },
    locale: 'fi-FI',
    
};
export default FiLang;